import React, { useState } from 'react';
import { useFinance } from '../contexts/FinanceContext';


function OnboardingModal() {
  const { state, completeOnboarding, setCurrency } = useFinance();
  const [selectedCurrency, setSelectedCurrency] = useState('₹');

  // If already onboarded, don't show
  if (state.isOnboarded) return null;

  const currencies = [
    { symbol: '₹', name: 'Indian Rupee' },
    { symbol: '$', name: 'US Dollar' },
    { symbol: '€', name: 'Euro' },
    { symbol: '£', name: 'British Pound' },
    { symbol: '¥', name: 'Japanese Yen' },
    { symbol: '₿', name: 'Bitcoin' },
  ];

  const handleFinish = () => {
    setCurrency(selectedCurrency);
    // Removed Initial Balance step as requested
    completeOnboarding();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      <div className="bg-slate-900 border border-slate-700 rounded-3xl p-8 max-w-lg w-full shadow-2xl relative overflow-hidden">
        {/* Background blobs */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent-500/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
        
        <div className="relative z-10 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-primary-500 to-accent-500 mb-6 shadow-lg shadow-primary-500/25">
            <span className="text-4xl">👋</span>
          </div>

          <h2 className="text-3xl font-bold text-white mb-2">Welcome to FinanceTracker</h2>
          <p className="text-slate-400 mb-8">Let's set up your currency to get started.</p>

          <div className="grid grid-cols-3 gap-3 mb-8">
            {currencies.map((c) => (
              <button
                key={c.symbol}
                onClick={() => setSelectedCurrency(c.symbol)}
                className={`p-4 rounded-2xl border-2 transition-all group ${
                  selectedCurrency === c.symbol
                    ? 'border-primary-500 bg-primary-500/10 shadow-lg shadow-primary-500/20'
                    : 'border-slate-700 bg-slate-800/50 hover:border-slate-500'
                }`}
              >
                <span className="text-3xl block mb-1 group-hover:scale-110 transition-transform">{c.symbol}</span>
                <span className="text-xs text-slate-400">{c.name}</span>
              </button>
            ))}
          </div>

          <button
            onClick={handleFinish}
            className="w-full py-4 rounded-xl bg-gradient-to-r from-primary-600 to-primary-500 text-white font-bold text-lg hover:from-primary-500 hover:to-primary-400 shadow-lg shadow-primary-500/25 transition-all transform hover:-translate-y-0.5"
          >
            Get Started 🚀
          </button>
          
          <p className="text-xs text-slate-500 mt-4">
            You can always change these settings later.
            <br/>To set your initial balance, just add an "Income" transaction!
          </p>
        </div>
      </div>
    </div>
  );
}

export default OnboardingModal;
